namespace Matrix.Visualizer {
    export interface GraphForm {
        GraphKey: Serenity.StringEditor;
        Description: Serenity.StringEditor;
        Version: StaticTextBlock;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
    }

    export class GraphForm extends Serenity.PrefixedContext {
        static formKey = 'Visualizer.Graph';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!GraphForm.init)  {
                GraphForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = StaticTextBlock;
                var w2 = ReadOnlyDateTime;

                Q.initFormType(GraphForm, [
                    'GraphKey', w0,
                    'Description', w0,
                    'Version', w1,
                    'CreatedBy', w1,
                    'CreatedWhen', w2,
                    'UpdatedBy', w1,
                    'UpdatedWhen', w2
                ]);
            }
        }
    }
}
